// import Vue from 'vue'
import axios from 'axios'; // 引入axios
// import getSign from './sign'  //引入getSign签名加密

/* eslint-disable */

import router from '@/router/router.js'
import {
    Message
} from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import $ from 'lodash'

// 二次封装Message
const showMessage = Symbol('showMessage')

class gtMessage {
  success(options, single=true) {
    this[showMessage]('success', options, single)
  }
  warning(options, single=true) {
    this[showMessage]('warning', options, single)
  }
  info(options, single=true) {
    this[showMessage]('info', options, single)
  }
  error(options, single=true) {
    this[showMessage]('error', options, single)
  }

  [showMessage](type, options, single) {
    if(single) {
      if(!document.querySelector('.el-message')) {
        Message[type](options)
      }
    } else {
      Message[type](options)
    }
  }
}

const gtMessageCase = new gtMessage();



NProgress.configure({
    easing: 'ease',
    speed: 500,
    showSpinner: false
})

axios.defaults.timeout = 1000000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';


// 环境的切换
if (process.env.NODE_ENV == 'development') {
    axios.defaults.baseURL = 'https://admintapi.moobyyoho.com';
} else {
    axios.defaults.baseURL = 'https://admintapi.moobyyoho.com';
}




// 请求拦截器
axios.interceptors.request.use(
    config => {
        NProgress.start()
        if (Vue.prototype.getToken()) {
            config.headers['MoobyYoho-Access-Token'] = Vue.prototype.getToken();
            // config.headers['MoobyYoho-Access-Token'] = 'mooby';
        }
        return config;
    },
    error => {
        return Promise.error(error);
    }
)


// 响应拦截器
axios.interceptors.response.use(response => {

    // 关闭加载框
    NProgress.done()

    if (response.status === 200) {
        // return  response
        // 判断状态码 过滤某些信息
        if (response.data.code == 20000) {
            return response
        } else if (response.data.code == 20001) {
            // Message({
            //     message: response.data.msg,
            //     type: 'error',
            //     duration: 1500,
            //     onClose() {
                    router.push({
                        path: "/"
                    })
            //     }
            // })
        } else if ([20002, 20003].includes(response.data.code)) {
            Message({
                message: response.data.msg,
                type: 'error',
                duration: 1500,
                onClose() {
                    router.push({
                        path: "/404"
                    })
                }
            })
        } else if (response.data.code == 20004) {
            // gtMessageCase.error({
            //     message: response.data.msg,
            //     // type: 'error',
            //     duration: 1500,
            // })
            return {}
        } else if ([20005, 20006].includes(response.data.code)) {
            Message({
                message: response.data.msg,
                type: 'error',
                duration: 1500,
            })
        }

    }
}, error => {
    // 关闭加载框
    NProgress.done()
    // Message({
    //     message: '网络出小差了，请稍后重试',
    //     type: 'error',
    //     duration: 2000
    // })
    return Promise.reject(error)
})




/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data)
        })
    });
}


/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 * @param {Object} config [请求头设置信息] 
 */
export function post(url, params, config) {
    return new Promise((resolve, reject) => {
        axios.post(url, params, config)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}



/** 
 * put方法，对应put请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function put(url, params) {
    return new Promise((resolve, reject) => {
        axios.put(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}


/** 
 * delete方法，对应delete请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function del(url, params) {
    return new Promise((resolve, reject) => {

        axios.delete(url, {
                data: params
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}


/** 
 * 图片上传
 */
export function upload(params) {
    return new Promise((resolve, reject) => {
        axios.post('/pic/upload', params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
/** 
 * 多图上传
 */
export function uploads(params) {
    return new Promise((resolve, reject) => {
        axios.post('/pic/uploads', params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

/** 
 * 图片删除
 */
export function imgDelete(id) {
    return new Promise((resolve, reject) => {
        axios.post(`pic/delpic/${id}`)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

/** 
 * 视频上传
 */
export function video(params) {
    return new Promise((resolve, reject) => {
        axios.post('/video/upload', params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}


/** 
 * 视频删除
 */
export function video_del(id) {
    return new Promise((resolve, reject) => {
        axios.post(`video/delvideo/${id}`)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}